import { track } from "../track";

type Source = "photo" | "video" | "prompt";

export const trackAvatarCreateTry = (params: {
  name: string;
  source: Source;
  archetype: string;
  arch_prompt?: string;
  photo_count?: number;
  text_prompt?: string;
  has_voice: boolean;
}) => {
  const eventSource = {
    photo: "photo",
    video: "video",
    prompt: "text_prompt",
  }[params.source];

  track({ event: "avatar_create_try", ...params, source: eventSource });
};
